
import { useLocation } from "react-router-dom";
import { useLevels } from "@dyl/systems/LevelsManager";

export default function useUrlLevel() {
    const { levels } = useLevels();
    const { pathname } = useLocation();

    const LEVEL_LABELS = levels.map(x => x.label.toLowerCase());

    const urlLevel = pathname
        .split('/')
        .map(x =>  LEVEL_LABELS.indexOf(x.toLowerCase()) !== -1 ? x : null)
        .filter(x => x !== null);

    return { urlLevel: urlLevel.length > 0 ? urlLevel[0] : null };
}
